import { getRecaptchaToken as execRecaptcha } from '@app/http-client';

import config from '../config';

/**
 * App-specific reCAPTCHA v3 wrapper. The shared, config-agnostic loader lives in
 * `@app/http-client`; here we just inject this app's site key so call sites stay
 * simple:
 *
 *   import { getRecaptchaToken } from '../../utils';
 *   const token = await getRecaptchaToken('ahc_package_lead');
 *
 * Returns `null` if no site key is configured (callers degrade gracefully).
 *
 * @param {string} action - lowercase action name (e.g. 'ahc_package_lead').
 * @returns {Promise<string|null>}
 */
export function getRecaptchaToken(action) {
  return execRecaptcha(config.recaptchaSiteKey, action);
}
